import { projects, units, paymentMethods, passwordRecoveryModal, editImage, changePasswordModal, profileForm, floorsList, catalogSettingsModal, filters, login, countries, } from 'i18n/en.common';
export default {
    translation: {
        main: {
            statistics: {
                tooltipText: 'Since the previous update',
                tooltipPreLaunchText: 'Pre-launch price',
                chartPreLaunchPointText: 'Pre-launch',
            },
            metroStation: {
                line: '{{lineCode}} line',
                plannedStation: 'planned station',
                builtStation: 'built station',
                subtitle: 'Metro station',
            },
            header: {
                title: { ...projects },
                search: {
                    placeholder: 'Search by project or developer name',
                    noMatch: 'No match',
                },
            },
            districtView: {
                description: 'Description',
                descriptionShow: 'Show',
                descriptionHide: 'Hide',
                developers: 'Developers',
                places: 'Places',
                projectsCount_one: '{{count}} project',
                projectsCount_two: '{{count}} projects',
                projectsCount_few: '{{count}} projects',
                projectsCount_many: '{{count}} projects',
                projectsCount_other: '{{count}} projects',
                from: 'From',
            },
            projectView: {
                tags: {
                    developerStock: 'DEVELOPER STOCK',
                    resale: 'RESALE',
                    preLaunch: 'PRE-LAUNCH',
                    soldOut: 'SOLD OUT',
                },
                descriptionShow: 'Show',
                descriptionHide: 'Hide',
                addToCatalog: 'Project to catalog',
                floor: 'floor',
                resale: 'Resale',
                distress: 'Distress',
                priceWithCommission: 'Price with commission',
                priceWithoutCommission: 'Price without commission',
                unitFeature: 'Unit Feature',
                unitView: 'View from the window',
                unitsOnRequestHint: {
                    start: 'Some units from the developer’s stock are available upon ',
                    link: 'manager’s',
                    end: ' request.',
                },
                unitsOnRequestBlockTitle: 'Units upon request',
                unitsOnRequestBlockTitleSome: 'Some developer units upon request',
                unitsOnRequestBlockDescription: 'Contact the manager to get all the details about units in this project.',
                unitContactsAria: 'Unit sales contacts',
                unitContactsModalTitle: 'Contacts',
                unitContactsModalOk: 'Ok',
                tabs: {
                    information: {
                        title: 'Information',
                        developer: 'Developer',
                        district: 'District',
                        price: 'Price',
                        pricePerSquare: 'Price per',
                        size: 'Size',
                        postHandover: 'Post handover',
                        handover: {
                            title: 'Completion',
                            ready: 'Ready',
                        },
                        ownershipType: {
                            title: 'Type of ownership',
                            leasehold: 'Leasehold',
                            freehold: 'Freehold',
                        },
                        unitType: 'Unit type',
                        serviceCharge: {
                            TH: 'Sinking fund/Maintance fee',
                            default: 'Service charge',
                        },
                        furnishing: 'Furnishing',
                        startOfSales: 'Start of sales',
                        eoi: {
                            title: {
                                MX: 'Reservation',
                                default: 'Expression of Interest (EOI)',
                            },
                            from: 'From',
                            upTo: 'Up to',
                            hint: {
                                MX: 'The final reservation amount depends on the selected unit and the seller\'s terms.',
                                default: 'The final EOI amount depends on the selected unit and the seller\'s terms.',
                            },
                        },
                        noc: 'Resale allowed after',
                        projectConfigurations: 'Project configurations',
                        managersContacts: 'Developer contacts',
                        managersName: 'Name',
                        managersPhone: 'Phone',
                        hide: 'Hide',
                        show: 'Show',
                        yes: 'Yes',
                        no: 'No',
                    },
                    units: {
                        title: 'Units',
                        ...units,
                        from: 'From',
                        floor: 'floor',
                        resale: 'Resale',
                        distress: 'Distress',
                        priceWithCommission: 'Price with commission',
                        priceWithoutCommission: 'Price without commission',
                        unitFeature: 'Unit Feature',
                        unitView: 'View from the window',
                    },
                    amenities: {
                        title: 'Amenities',
                    },
                    paymentPlans: {
                        title: 'Payment plans',
                        postHandover: 'Post Handover',
                        noPostHandover: 'No Post Handover',
                        ...paymentMethods,
                    },
                    documentsAndVideos: {
                        title: 'Documents & Videos',
                    },
                    placesNearby: {
                        title: 'Places nearby',
                    },
                    seller: {
                        title: 'Seller',
                        salesManagers: 'Sales managers',
                        salesManagersDescription: 'Contacts',
                        resaleContactsHint: 'For resale unit contacts, please refer to the unit card.',
                        comission: 'Commission',
                        comissionDescription: 'Applicable commission fee',
                        comissionItemDescription: 'Rate for deals',
                        address: 'Office location',
                        descriptionShow: 'Show',
                        descriptionHide: 'Hide',
                        clipboard: 'Copied!',
                    },
                },
                placesNearby: {
                    meters: 'meters',
                },
                seller: {
                    title: 'Seller',
                    salesManagers: 'Sales managers',
                    salesManagersDescription: 'Contacts',
                    resaleContactsHint: 'For resale unit contacts, please refer to the unit card.',
                    commission: 'Commission',
                    commissionDescription: 'Applicable commission fee',
                    commissionItemDescription: 'Rate for deals',
                    address: 'Office location',
                    descriptionShow: 'Show',
                    descriptionHide: 'Hide',
                    clipboard: 'Copied!',
                },
            },
        },
        personal: {
            companies: {
                broker: 'Broker',
                developer: 'Developer',
                agency: 'Agency',
            },
        },
        settings: {
            title: 'Settings',
            profile: {
                title: 'Profile',
            },
            language: {
                title: 'Language',
                ru: 'Russian',
                en: 'English',
                ar: "Arabic",
            },
            currency: {
                title: 'Currency',
            },
            measures: {
                title: 'Measures',
            },
            map: {
                title: 'Map',
            },
            showDistricts: {
                title: 'Show districts on map',
            },
        },
        profile: {
            title: 'Profile',
            changePassword: 'Change password',
            logout: 'Log out',
            cancel: 'Cancel',
            save: 'Save',
        },
        catalog: {
            title: 'Catalog',
            clear: 'Clear',
            preview: 'Preview',
            floor: 'floor',
            ...floorsList,
            empty: {
                title: 'Your catalog is empty',
                description: 'Add projects or objects from the map to start working with your catalog',
                button: 'Go to map',
            },
        },
        preview: {
            title: 'Preview',
            generate: 'Create catalog',
        },
        login,
        resetPassword: {
            header: 'Password recovery',
            body: 'Create a new password. It must be at least 8 characters long and include at least one uppercase and lowercase letter, number, and symbol.',
            uppercaseAndLowercaseLetterTitle: 'The password must contain at least one lowercase and one uppercase letter.',
            oneDigitTitle: 'The password must contain at least one digit.',
            specialSymbolTitle: 'The password must contain at least one special character.',
            minimumLengthTitle: 'The password length must be at least 8 characters.',
            password: 'New password',
            passwordConfirmation: 'Confirm your new password',
            passwordSubmited: {
                header: 'You now have a new password!',
                body: 'The new password has been successfully created and you can now use it to log into Geniemap.',
            },
            createPassword: 'Save password',
            ok: 'Ok',
        },
        projectsList: {
            projects_one: '{{ count }} project',
            projects_two: '{{ count }} projects',
            projects_few: '{{ count }} projects',
            projects_many: '{{ count }} projects',
            projects_other: '{{ count }} projects',
            noResultsFound: 'No result found',
            tryDifferentSearchOptions: 'Try using different search options',
            project: {
                tags: {
                    developerStock: 'DEVELOPER STOCK',
                    resale: 'RESALE',
                    preLaunch: 'PRE-LAUNCH',
                    soldOut: 'SOLD OUT',
                },
                priceFrom: 'Price from',
                handover: 'Handover',
            },
        },
        common: {
            passwordRecoveryModal,
            changePasswordModal,
            editImage,
            profileForm,
            catalogSettingsModal,
            filters,
            countries: countries,
        },
        ws: {
            catalog: {
                start_catalog_generate: 'The catalog has started generating.',
                catalog_generated: 'Catalog successfully created',
                warning: 'Warning',
            },
            auth: {
                logout: 'You have been logged out due to a large number of connections from your account.',
            },
        },
    },
};
